import angular from 'angular';
import {
  ssDialogService,
  loaderService,
  emDataService,
  emSharedModelService,
} from 'app/services';
import { alerts, actionIcon, importDocument } from 'app/components/global';
import addFunctionVendorDialog from '../vendors/dialog.addFunctionVendorDialog';
import infrastructureOptions from '../infrastructureOptions';
import internalSystemOptions from '../internalSystemOptions';
import vendors from '../vendors';
import validator, { name as validatorName } from './messages/function-unique-name.validator.directive';
import controller from './edit-function-dialog.controller';
import template from './edit-function-dialog.html';
import messages from '../messages/function.name.messages.html';
import itAsset from '../ITAsset';
import nonITAsset from '../nonITAsset';
import addAssetTypeDialog from '../dialog.addAssetTypeDialog';


class dialogService {
  getOptions($event, {
    customerId = -1,
    department = null,
    process = null,
    functionObj = null,
    addCallback,
    updateCallback,
  }) {
    return {
      controller,
      controllerAs: 'editFunctionDialogVM',
      locals: {
        customerId,
        department,
        process,
        function: functionObj,
        addCallback,
        updateCallback,
      },
      bindToController: true,
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.enterpriseModeling.editFunctionDialog', [
  alerts,
  actionIcon,
  ssDialogService,
  loaderService,
  emDataService,
  emSharedModelService,
  addFunctionVendorDialog,
  infrastructureOptions,
  internalSystemOptions,
  vendors,
  importDocument,
  itAsset,
  nonITAsset,
  addAssetTypeDialog
])
  .directive(validatorName, validator)
  .service('editFunctionDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('function.name.messages.html', messages);
  })
  .name;

console.log('app.components.advisory.enterpriseModeling.editProcessDialog created');
